<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Input
              class="search-ipt"
              type="text"
              v-model="keyword"
              placeholder="请输入方案名称"
              @on-enter="getPlanList"
              clearable
            />
            <Button
              type="primary"
              icon="md-search"
              class="search_tn"
              data-level="common"
              @click="getPlanList"
            >搜索</Button>
            <Button class="top_search_btn" type="primary" icon="md-add" @click="addEditorShow">新建</Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData">
        <template slot-scope="{ row, index}" slot="action">
          <a class="jump_color" @click="addEditorShow(row)">修改配置</a>
          <a class="jump_color" @click="showDeleteModal(row)">删除</a>
        </template>
      </Table>
    </div>
    <Modal
      v-model="deleteModalStatus"
      width="350"
      title="提示"
      @on-ok="deleteItemConfirm"
      @on-cancel="deleteCancel"
    >
      <p style="font-size:20px;">确定删除“{{currentTitle}}”？</p>
    </Modal>
    <Modal
      v-model="addEditorFlag"
      width="550"
      title="新增/编辑"
      @on-ok="AddEditorConfirm"
      @on-cancel="AddEditorCancel"
    >
      <div class="modal_item_wrapper">
        <span class="modal_label">名称</span>
        <Input class="item_context" v-model="planName" />
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">配置</span>
        <Select v-model="selectedConfigList" class="item_context" multiple>
          <Option v-for="item in configList" :value="item.id" :key="item.id">{{item.parameterName}}</Option>
        </Select>
      </div>
    </Modal>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getPlanList"></paging>
  </div>
</template>
<script>
import paging from "../templates/Paging.vue";
import {
  _getPlanList,
  _holdTestPlan,
  _getConfigList,
  _getTestConfigDetail,
  _deletePlanItem
} from "../api/api";
import { alertTips, dealDate } from "../common/common.js";
export default {
  name: "OCRSetting",
  components: { paging },
  data() {
    return {
      pageSize: 10, // 每页条数
      currentNum: 0, // 当前页码
      totalNum: 0, // 数据总条数
      keyword: "", // 搜索内容
      deleteModalStatus: false, // 删除Modal状态
      addEditorFlag: false, // 新增、编辑Modal
      currentTitle: "", // 当前要删除的方案标题
      currentId: 0, //当前选中方案id
      planName: "", // 方案名
      configList: [], // 配置列表
      selectedPlanId: 0, // 当前选中的方案id
      selectedConfigList: [], // 选中的配置列表
      tableHeader: [
        {
          title: "名称",
          key: "schemeName"
        },
        {
          title: "更新时间",
          key: "updateTime"
        },
        {
          title: "操作",
          slot: "action"
        }
      ],
      tableData: []
    };
  },
  methods: {
    //      新建、编辑Modal显示
    addEditorShow(row) {
      this.addEditorFlag = true;
      this.getConfigList();
      if (row.id) {
        this.planName = row.schemeName;
        this.selectedPlanId = row.id;
        this.getTestConfigDetail();
      }
    },
    //      获取某条方案的配置详情
    getTestConfigDetail() {
      const self = this;
      _getTestConfigDetail(self.selectedPlanId).then(res => {
        if (res.code === 0) {
          if (res.data.itemList && res.data.itemList.length > 0) {
            res.data.itemList.forEach(item => {
              self.selectedConfigList.push(item.parameterId);
            });
          }
        } else {
        }
      });
    },
    // 获取配置列表
    getConfigList() {
      const self = this;
      _getConfigList().then(res => {
        if (res.code === 0) {
          self.configList = res.data.content;
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //      新建、编辑确认
    AddEditorConfirm() {
      const self = this;
      let selectedConfigList = [];
      self.selectedConfigList.forEach(item => {
        selectedConfigList.push({
          parameterId: item
        });
      });
      let dataInfo = {
        id: self.selectedPlanId,
        schemeName: self.planName,
        itemList: selectedConfigList
      };
      _holdTestPlan(dataInfo).then(res => {
        if (res.code === 0) {
          self.planName = "";
          self.selectedConfigList = [];
          self.selectedPlanId = 0;
          self.getPlanList();
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //      新增、编辑取消
    AddEditorCancel() {
      this.planName = "";
      this.selectedPlanId = 0;
      this.selectedConfigList = [];
    },
    //      删除Modal显示
    showDeleteModal(row) {
      this.currentId = row.id;
      this.currentTitle = row.schemeName;
      this.deleteModalStatus = true;
    },
    //      确认删除
    deleteItemConfirm() {
      const self = this;
      _deletePlanItem(self.currentId).then(res => {
        if (res.code === 0) {
          self.currentId = 0;
          self.getPlanList();
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //      删除取消
    deleteCancel() {
      this.currentId = 0;
      this.currentTitle = "";
    },
    //      获取识别方案列表
    getPlanList() {
      const self = this;
      self.currentNum =
        typeof msg === "object" && msg.pageNum ? msg.pageNum : 1;
      let paramsInfo = {
        page: self.currentNum - 1,
        size: self.pageSize,
        sort: "updateTime,desc"
      };
      _getPlanList({ params: paramsInfo }).then(res => {
        if (res.code === 0) {
          res.data.content.forEach(item => {
            item.updateTime = dealDate(item.updateTime);
          });
          self.tableData = res.data.content;
          self.totalNum = res.data.total;
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //      去编辑
    editorItem(row) {
      this.planName = row.schemeName;
    }
  },
  mounted() {
    this.getPlanList();
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OCRSetting.vue